import api from './config'

export function getBankList() {
    return api.post('sel/getBankList', {});
}